import { ViewController } from 'elc-service';
import { SignInLinkUseCase } from '../use-cases/SignInLinkUseCase';
import { computed } from 'mobx';
import { diContainer, serviceNames } from '../../service-setup/diContainer';
import { AuthSessionRepository } from '../repositories/AuthSessionRepository';

export class NavLinkViewController extends ViewController {
    private authSessionRepository: AuthSessionRepository;

    constructor() {
        super();
        this.authSessionRepository = diContainer.get(serviceNames.authSessionRepository);
    }

    @computed
    get data() {
        return {
            isAuthenticated: this.authSessionRepository.authSession.isAuthenticated
        };
    }

    public onSignInLinkClick = () => {
        const useCase = new SignInLinkUseCase();
        useCase.execute();
    };
}
